import { useTranslation } from "react-i18next"

const NestpayLogo = ({height}) => {
    const {t} = useTranslation()
  return (
    <div 
        className="flex gap-2 items-center w-fit" 
        style={{
            height: height,
        }}
    >
        <div 
            style={{
                height: height,
                position: "relative",
                width: height,
            }}
        >
            <img
                src="/static/images/png/nestpay_logo.png" 
                alt="Nestpay Logo"
                style={{
                    height: "100%",
                    width: "100%",
                    position:"absolute",
                    borderRadius: "5px",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    margin: "auto",
                }}                
            />
        </div>
        <span className="font-medium text-2xs sm:text-sm">
            {t("bills.bill_info.other")}
        </span>
    </div>
  )
}

export default NestpayLogo